import Backbone from 'backbone';
import React from 'react';
import ReactDOM from 'react-dom';

import AnalyticsDashboardDetails from 'insights/analytics-dashboards/details/AnalyticsDashboardDetails';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';

import {DEFAULT_DASHBOARD_DETAILS_CONTEXT} from '../details/AnalyticsDashboardDetailsContext';
import AnalyticsDashboardTabState from './AnalyticsDashboardTabState';

export default class AnalyticsDashboardTabView extends Backbone.View<AnalyticsDashboardTabState> {
  static initClass(): void {
    this.prototype.className = 'buffer-tab buffer-tab--no-padding';
  }

  override render(): this {
    const props = {
      analyticsDashboardId: this.model.get('analyticsDashboardId'),
      viewStateId: this.model.get('viewStateId'),
    };
    renderToDOM(<AnalyticsDashboardDetails {...props} {...DEFAULT_DASHBOARD_DETAILS_CONTEXT} />, this.el);
    return this;
  }

  override remove(): Backbone.View<AnalyticsDashboardTabState> {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

AnalyticsDashboardTabView.initClass();
